import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Theme } from '@mui/material/styles';

import { clone, isObject } from '../../../core/utils';
import { formatDate } from '../../../components/renderers';
import { create, isValid } from '../../../components/form';
import { extendedstyles } from '../../appstyles';

const s:any = {
  reqform: {
    //
  },
};

class InspectionPanel extends Component<any, any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props: any) {
    super(props);
    this.state = {
      source: {},
      preview: false,
      valid: false,
      count: 0,
    };
  }

  componentDidMount() {
    this.props.setValid(this.state.valid);
  }

  formconfig = () => {
    //combo.inputLabelProps => cilp
    //const cbip = {InputLabelProps:{ shrink:true,}};
    const config = {
      service:{
      name:'monitoring',
      title:'Monitoring',
      key:'rid',
      num: false,
      fields:['rid','ttl','sch','rfn','eni','ens','enc','etc','nsi','nsk','nsn','nsu','nsr','sts','ast','stp'],
      grid  : [['ttl','Title'],['tmn','Team'],['lcc','Location'],['smr','Summary'],['prc','Priority'],['rlc','Risk Level'],['dat','Dated'],['stp','Stamp']],
      bar: {pag:true,btn:['add','edit','del','view','man','wiz']},
      menu: {mnu:[{t:'Name',v:'nam'},{t:'Code',v:'shc'}],def:'nam'},
      eform:[
        {id:'ttl',label:'Title',type:'tf',req:1,ops:{}},
        // {id:'shc',label:'Shortcode',type:'tf',req:0,ops:{}},
        {id:'eni',label:'Entity',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'inspectionentity'},chs:['lci']},
        // {id:'tmi',label:'Team',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'team'}},
        {id:'iti',label:'Monitoring Type',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'monitoringtype'}},
        {id:'lci',label:'Location',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'inspectionlocation'},pns:['eni']},
        {id:'smr',label:'Summary',type:'tf',req:1,ops:{},},
        {id:'dat',label:'Due Date',type:'df',req:1,ops:{}},
        {id:'pri',label:'Priority',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'monitoringpriority'}},
        {id:'rli',label:'Risk Level',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'monitoringrisklevel'}},
        // {id:'sti',label:'Inspection State',type:'fa',req:0,ops:{},cp:{t:'bcs',s:'inspectionstate'}},
        {id:'exi',label:'Extra Info',type:'jf',req:0,ops:{}},
        // {id:'sts',label:'Status',type:'fa',req:0,ops:{},cp:{t:'lcs',s:'status'}},
      ],
    },
    create:true,
    //actions: {add:'Add',view:'View'},
    //panels: {add:'simple',view:'simple'}
    actions: {add:'Add'},
    panels: {add:'simple',}
    };
    return config;
  };

  setValid = (data: any) => {
    const sconfig = this.formconfig();
    const { mode } = this.props;
    const valid = ['del', 'delete'].includes(mode)
      ? true
      : isValid(sconfig, data, mode);
    //console.log('valid:',valid);

    //const valid = (!!newdata.nam && !!newdata.agc && !!newdata.mbn && !!newdata.lci);
    //const valid = (!!data.wsu && !!data.cbu && !!data.cbc && !!data.cba);
    //console.log('valid:',valid);
    this.props.setValid(valid);
  };

  onChange = (name: any) => (value: any) => {
    const { data } = this.props;
    const newdata = { ...data.data, [name]: value };
    this.setValid(newdata);
    this.props.setItem('data', 'data', newdata);
  };

  makeform = () => {
    const config = this.formconfig();

    const { record, extras, classes } = this.props;
    console.log('debug','accountpanel.makeform.recrd:',JSON.stringify(record));
    // if(isObject(record)){
    //   record.amk = 1;
    // }
    const newrecord = {...(record||{}),amk:1};
    console.log('debug','accountpanel.makeform.newrecrd:',JSON.stringify(newrecord));
    const sconfig = clone(config);
    const sdata = sconfig.service;
    const mode = 'add';
    const formatters = { dob: formatDate };
    const onChange = this.onChange.bind(this);
    const form = create(mode,sdata,newrecord,formatters,onChange,classes,extras);
    return form;
  };

  render() {
    //const {data,classes} = this.props;
    const form = this.makeform();
    return form;
  }
}

InspectionPanel.propTypes = {
  classes: PropTypes.object,
};

export default InspectionPanel;
